<template>
  <label
    class="radio-input"
    :for="`radio-${name}-${value}`"
    tabindex="0"
  >
    <Field
      class="radio-input__input"
      :name="name"
      :label="label"
      type="radio"
      :value="value"
      :id="`radio-${name}-${value}`"
      :rules="rules ?? ''"
      checked
    />
    <span class="radio-input__radio" />
    <span class="radio-input__label">
      {{ label }}
    </span>
  </label>

  <ErrorMessage
    as="span"
    class="input__error | input-error"
    :name="name"
  />
</template>

<script>
  import { ErrorMessage, Field } from "vee-validate";

  export default {
    components: {
      ErrorMessage,
      Field,
    },
    props: {
      name: {
        type: String,
        default() {
          return '';
        }
      },
      rules: {
        type: [String, Object],
        default: ''
      },
      label: String,
      value: {
        type: String,
        default: 'Firma',
      },
    },
  };

</script>
